import { OPERATORS } from 'src/app/services/constants';
import { BandTooltipStrategy } from './band-tooltip-strategy.interface';

export class OskBandTooltipStrategy implements BandTooltipStrategy {
  matches(operatorKey: string, operatorMetadata: any, taskSensor: any): boolean {
    return operatorKey === OPERATORS.OSK;
  }

  buildTooltip(operatorMetadata: any, taskSensor: any): string {
    return operatorMetadata?.tooltip || '';
  }
}
